import { Box, Button, Card, CardContent, CardHeader, LinearProgress, makeStyles, Table, TableBody, TableCell, TableRow, TextField, Typography } from '@material-ui/core';
import { red } from '@material-ui/core/colors';
import { mapAdjustTransactionToServiceItems, mapRemovePackagedServices, mapServiceToTransactionList } from 'components/ServiceCard/ServiceCard.types';
import { isEmpty } from 'lodash';
import { adjustTransactionAsIdsState, adjustTransactionState, calculatedTransactionAmountState, promoState } from 'pages/CustomerBooking/RecoilState';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { toast } from 'react-hot-toast';
import { useRecoilState, useRecoilValue } from 'recoil';
import { applyPromoCode, calculatePayment } from 'services/payments.service';
import { getServices, getWhitelabelServices } from 'services/service.service';
import { localizeCurrency } from 'util/localizeFormat';
import { useTrackEvent } from 'util/trackEvent';
import { CartTable } from '../CartTable';
import { ServiceModifierDialog } from './ServiceModifierDialog';
import { filterNonNull } from 'util/format';
import { toasterror } from 'util/toasterror';

const useStyles = makeStyles((theme) => {
  return {
    boxed: {
      width: "100%",
      display: "flex",
      flexWrap: "wrap",
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "center",
      alignContent: "center",
      "&>*": {
      }
    },
    boxedInput: {
      flexGrow: 1,
      marginRight: theme.spacing(1),
    },
    boxedInputLabel: {
      fontStyle: "italic",
      textTransform: "none",
    },
    noPay: {
      textDecoration: 'line-through',
      color: red[500],
      // paddingRight: theme.spacing(1)
    }

  }
})
const Transaction = ({ booking, readOnly = false }) => {
  const classes = useStyles()
  const enablePromoCode = false
  const [loading, setLoading] = useState(false);
  const [transaction, setTransaction] = useState(null)
  const [promoCode, setPromoCode] = useState('');
  const [cartTable, setCartTable] = useState(null);
  const [availableServices, setAvailableServices] = useState([]);
  const [selectedServices, setSelectedServices] = useState([]);
  const [promo, setPromo] = useRecoilState(promoState);
  const [promoError, setPromoError] = useState();
  const adjustTransactionIds = useRecoilValue(adjustTransactionAsIdsState);

  const [adjustTransaction, setAdjustTransaction] = useRecoilState(adjustTransactionState);

  const [calculatedTransaction, setCalculatedTransaction] = useRecoilState(calculatedTransactionAmountState);
  const fetchServices = useCallback(
    async ({ filter }) => {
      const params = {
        longitude: booking?.user_location?.longitude,
        latitude: booking?.user_location?.latitude,
        city: booking?.city?.id
      }
      try {
        let services = []

        if (booking?.is_whitelabel) {
          services = await getWhitelabelServices({
            ...params,
            wlp_id: booking?.white_label_partner?.id,
            filter_items: filter
          })
        } else {
          services = await getServices({
            ...params,
            filter_items: filter
          })
        }
        return services
      } catch (error) {
        toasterror(error?.message?.en || error?.response?.data?.message?.en || error?.response?.data?.details)
      }
      return null
    },
    [booking?.location],
  );

  // const fetchAvailableServices = useCallback(
  //   async () => {
  //     const services = await fetchServices({filter:true})
  //     setAvailableServices(mapRemovePackagedServices({
  //       baseServices: services?.services,
  //       adjustTransaction
  //     }))
  //   },
  //   [],
  // );

  // useEffect(
  //   () => {
  //     fetchAvailableServices()
  //   }, [adjustTransaction]
  // );

  const calculateTransaction = useCallback(
    async () => {
      if (!adjustTransaction) return
      setLoading(true)
      let promoParams = filterNonNull({
        "code": promo?.code || booking?.promo?.code,
        "code_type": promo?.type || booking?.promo?.type,
      })
      
      if (!isEmpty(promoParams)) {
        promoParams = {
          ...promoParams,
          should_check_for_promo_usage: false
        }
      }
      const params = {
        ...promoParams,
        "address": booking?.user_location?.address,
        "notes": booking?.user_location?.notes,
        "lng": booking?.longitude,
        "client_type": "web",
        "lat": booking?.latitude,
        "location_id": booking?.user_location?.id,
        "booking_option": booking?.booking_option,
        "type": booking?.type?.id,
        "service_addon_order": booking?.service_addon_order,
        "extended_package_items": booking?.extended_package_items?.map(item => item?.item?.id),
        "extended_packages": booking?.extended_packages?.map(item => item?.package?.id),
        "packages": booking?.packages,
        "options": booking?.booking_options?.map(item => item?.id),
        "duration": booking?.duration,
        "wlp_id": booking?.white_label_partner?.id,
        "white_label_customer": booking?.white_label_customer?.id,
        ...adjustTransactionIds
      }

      try {
        const results = await calculatePayment(booking?.client?.id, params)


        
        setTransaction(results)
        setCalculatedTransaction(results?.total)
        const services = await fetchServices({ filter: false })
        setAvailableServices(mapRemovePackagedServices({
          baseServices: services?.services,
          adjustTransaction
        }))
        setSelectedServices(mapAdjustTransactionToServiceItems({
          adjustTransactions: adjustTransaction,
          services
        }))
        const map = mapServiceToTransactionList({
          booking,
          adjustTransaction,
          transaction: results,
          services
        })
        setCartTable(map)


      } catch (error) {
        toasterror(error?.message?.en || error?.response?.data?.message?.en || error?.response?.data?.details)
      } finally {
        setLoading(false)
      }


    },
    [promo, adjustTransactionIds, adjustTransaction, booking?.booking_option, booking?.booking_options, booking?.client?.id, booking?.duration, booking?.extended_package_items, booking?.extended_packages, booking?.latitude, booking?.longitude, booking?.packages, booking?.service_addon_order, booking?.type?.id, booking?.user_location?.address, booking?.user_location?.id, booking?.user_location?.notes],
  );


  // useUpdateEffect(
  //   () => {
  //       calculateTransaction()
  //   }, [promo, adjustTransaction, booking?.id]
  // );

  useEffect(
    () => {
      calculateTransaction()
    }, [promo, adjustTransaction, booking?.id]
  );
  const trackEvent = useTrackEvent()


  const submitPromoCode = useCallback(
    async () => {
      try {
        const result = await applyPromoCode(promoCode)
        setPromo(result);
      } catch (e) {
        setPromoError(e?.response?.data?.message?.en)
      }
    },
    [promoCode],
  );

  const renderTotal = useMemo(
    () => {
      if (transaction?.partner_covered > 0) {
        return (
          <>
            <Typography component="span" variant="overline" color="error" style={{ textDecoration: 'line-through', paddingRight: 10 }}>{localizeCurrency(transaction?.sub_total)}</Typography>
            <Typography component="span" variant="body2" color="textPrimary" style={{ fontWeight: 'bold' }} >
              {localizeCurrency(transaction?.total)}
            </Typography>
          </>
        )
      }
      return <Typography variant="body2" color="textPrimary" style={{ fontWeight: 'bold' }} >
        {localizeCurrency(transaction?.total)}
      </Typography>
    }, [transaction]
  );
  const displayNote = useMemo(
    () => {
      return (
        <TableRow>
          <TableCell colSpan={2} align="center">
            <Typography
              style={{ fontStyle: "italic" }}
              variant="caption" color="textSecondary">{(transaction?.total > 0 && !readOnly) && 'Adding of payment method is required.  '}You will not be charged until service is complete</Typography>
          </TableCell>
        </TableRow>

      )

    }, [transaction?.total, readOnly]
  );

  if (loading) {
    return <LinearProgress variant='query' />
  }
  return (
    <Card>
      <CardHeader title="Payment Summary" />
      <CardContent>
        {/* <Typography variant="body1" color="textSecondary" component="p">Transaction Date: {moment(transaction?.timestamp).format('LL LT')}</Typography> */}
        {/* <Typography variant="body1">Status: <Chip size="small" label={transaction?.status} /></Typography> */}
        <CartTable cartTable={cartTable} readOnly />
          <ServiceModifierDialog
            readOnly={readOnly}
            promo={promo}
            booking={booking}
            displayCoverage={booking?.is_whitelabel}
            services={availableServices}
            selectedServices={selectedServices}
            onSetServices={selectedServices => {

            }}
          />
        <Table>
          <TableBody>
            <TableRow>
              <TableCell align='start'>Subtotal</TableCell>
              <TableCell align='right' variant="head">{localizeCurrency(transaction?.service)}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell align='start'>Service Fee</TableCell>
              <TableCell align='right' variant="head">{localizeCurrency(transaction?.base)}</TableCell>
            </TableRow>
            <TableRow selected>
              <TableCell align='start'>Total</TableCell>
              <TableCell align='right' variant="head">{localizeCurrency(transaction?.sub_total)}</TableCell>
            </TableRow>
            {enablePromoCode &&
              <TableRow>
                <TableCell align='start'>Discount</TableCell>
                <TableCell align='right' >-{localizeCurrency(transaction?.discount)}</TableCell>
              </TableRow>
            }
            <TableRow>
              <TableCell align='start'>Covered By {booking?.white_label_partner?.label}</TableCell>
              <TableCell align='right' >-{localizeCurrency(transaction?.partner_covered)}</TableCell>
            </TableRow>
            {
              (enablePromoCode && !readOnly) && (
                <TableRow>
                  <TableCell colSpan={2}>
                    <Box className={classes.boxed}>
                      <TextField
                        className={classes.boxedInput}
                        value={promoCode}
                        onChange={(e) => {
                          // trackEvent('Promo Code - change', { value: e.target.value })
                          setPromoCode(e.target.value)
                          setPromoError(null)
                        }}
                        size="small" hiddenLabel variant="outlined"
                        error={!!promoError}
                        helperText={promoError}
                      />
                      <Button onClick={() => {
                        trackEvent('Promo Code - Added', { value: promoCode })
                        submitPromoCode()
                      }} color="primary" variant="text" className={classes.boxedInputLabel}>Add Promo Code</Button>
                    </Box>
                  </TableCell>
                </TableRow>
              )
            }
            {transaction?.discount_promo > 0 && (
              <TableRow>
                <TableCell align='start'>Promo Discount</TableCell>
                <TableCell align='right' variant="head">{localizeCurrency(transaction?.discount_promo)}</TableCell>
              </TableRow>
            )}
            {!isEmpty(transaction?.additionals) && (
              <TableRow>
                <TableCell padding="none" colSpan={2} variant="head" align='start'>Additionals</TableCell>
              </TableRow>
            )}
            {(transaction?.additionals ?? []).map((additional, index) => (
              <TableRow>
                <TableCell align='start'>{additional?.label}</TableCell>
                <TableCell align='right' variant="head">{localizeCurrency(additional?.amount)}</TableCell>
              </TableRow>
            ))}
            <TableRow selected>
              <TableCell variant="head" align='start'>Amount to be paid</TableCell>
              <TableCell align='right' variant="head">{renderTotal}</TableCell>

            </TableRow>
            {displayNote}
          </TableBody>
        </Table>


      </CardContent>
    </Card>
  )
}

export { Transaction };
